import { Injectable } from '@angular/core';
import { ITaskDto } from 'core/dto';
import { Observable } from 'rxjs';
import { ApiService } from '../api.service';
import { controllerEndpoints } from '../controller.endpoints';
import { crudEndpoints } from '../crud.endpoints';
import { customEndpoints } from '../custom.endpoints';
import joinUrls from '../utils.ts/join-urls';
import { ICrudAdvancedMethods } from './types/i-crud-advanced.methods';
import { ICrudBasicMethods } from './types/i-crud-basic.methods';
import { IGetByActivity } from './types/i-get-by-activity';
import { IGetByProcess } from './types/i-get-by-process';

@Injectable({
  providedIn: 'root'
})
export class TaskRemoteControllerService implements
  ICrudBasicMethods<ITaskDto>,
  IGetByProcess<ITaskDto>,
  IGetByActivity<ITaskDto>,
  Pick<ICrudAdvancedMethods<ITaskDto>, 'insertBatch' | 'removeBatch' | 'updateBatch' | 'reorder'> {

  private readonly _endpoint = controllerEndpoints.TASK

  constructor(
    private readonly _apiService: ApiService
  ) { }


  getByActivity(activityId: string) {
    const getByActivityEndpoint = joinUrls(this._endpoint, customEndpoints.GET_BY_ACTIVITY_ID);
    return this._apiService.get<ITaskDto[]>(getByActivityEndpoint, { activityId })
  }

  getByProcess(processId: string): Observable<ITaskDto[]> {
    const getByProcessEndpoint = joinUrls(this._endpoint, customEndpoints.GET_BY_PROCESS_ID);

    return this._apiService.get<ITaskDto[]>(getByProcessEndpoint, { processId })
  }

  getOne(id: string) {

    const getOneEndpoint = joinUrls(this._endpoint, id)
    return this._apiService.get<ITaskDto>(getOneEndpoint)
  }

  update(id: string, updateDto: Partial<ITaskDto>) {
    const updateEndpoint = joinUrls(this._endpoint, id);
    return this._apiService.put<ITaskDto>(updateEndpoint, updateDto);
  }

  create(insertDto: Partial<ITaskDto>) {
    return this._apiService.post<ITaskDto>(this._endpoint, insertDto);
  }

  remove(id: string) {
    const removeEndpoint = joinUrls(this._endpoint, id);
    return this._apiService.delete(removeEndpoint)
  }

  removeBatch(id: string[]) {

    return this._apiService.post<string[]>(this._endpoint, { id })
  }

  insertBatch(insertDtoArray: Partial<ITaskDto>[]): Observable<ITaskDto[]> {
    const insertBatchEndpoint = joinUrls(this._endpoint, crudEndpoints.INSERT_BATCH);
    return this._apiService.post(insertBatchEndpoint, insertDtoArray)
  }

  updateBatch(updatePairs: { id: string; updateDto: Partial<ITaskDto>; }[]): Observable<ITaskDto[]> {
    const updateBatchEndpoint = joinUrls(this._endpoint, crudEndpoints.UPDATE_BATCH);
    return this._apiService.post(updateBatchEndpoint, updatePairs)
  }

  reorder(reorderPairs: { id: string; orderIdx: number; }[]) {
    const reorderEndpoint = joinUrls(this._endpoint, crudEndpoints.REORDER);
    return this._apiService.post(reorderEndpoint, reorderPairs)
  }

}
